import React from 'react';
import { useNavigate } from 'react-router-dom';
// Optional: import CSS file

const FeedbackSelectionPage = () => {
    const navigate = useNavigate();

    const handleEagleClick = () => {
        navigate('/eagle-feedback');
    };
    const handleStreaksClick = () => {
        navigate('/streaks-feedback');
    };
    const handleTurboClick = () => {
        navigate('/turbo-feedback');
    };

    return (
        <div style={{ textAlign: 'center' }}>
            <h1>Select Feedback Type</h1>
            {/*<div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>*/}
            {/*<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>*/}
            {/*    <div style={{ border: '0px solid #ccc', padding: '5px' }}>*/}
            {/*        <button className="btn-search" onClick={handleEagleClick}>Improved Earning Structure Feedback</button>*/}
            {/*    </div>*/}
            {/*    <div style={{ border: '0px solid #ccc', padding: '5px' }}>*/}
            {/*        <button className="btn-search" onClick={handleStreaksClick}>Streaks Plus Feedback</button>*/}
            {/*    </div>*/}
            {/*    <div style={{ border: '0px solid #ccc', padding: '5px' }}>*/}
            {/*        <button className="btn-search" onClick={handleTurboClick}>Turbo Feedback</button>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <br/>
            <div className="d-flex flex-column align-items-center gap-3 w-100">
                <button className="btn btn-outline-success btn-lg w-100 feedback-btn shadow" onClick={handleEagleClick} >Improved Earning Structure Feedback</button>
                <button className="btn btn-outline-success btn-lg w-100 feedback-btn shadow" onClick={handleStreaksClick} >Streaks Plus Feedback</button>
                <button className="btn btn-outline-success btn-lg w-100 feedback-btn shadow" onClick={handleTurboClick} >Turbo Feedback</button>
            </div>
        </div>
    );
};

export default FeedbackSelectionPage;